<template>
  <template v-if="loading">
    <slot name="loading"></slot>
  </template>
  <slot v-else></slot>
</template>

<script setup lang="ts">
defineProps({
  loading: {
    type: Boolean,
    required: true,
  },
});
</script>
